module.exports = __webpack_public_path__ + "img/seminar (24).9be5d80e.jpg";